import EnvConstant from '../constants/EnvConstant';
import styled from './styled';
import * as mixin from './mixin';

/**
 * ラウンジとは？ベース
 */
export const Article = styled('article').attrs({
  className: 'bg-white',
})`
  border-top: ${props => (props.theme.isSp ? '5px solid #34a413' : 'none')};
  text-align: center;
  line-height: 1.6;

  section {
    padding-bottom: 10px;
    text-align: left;
  }

  h1 {
    padding: ${props => (props.theme.isSp ? '10px 0 0' : '0')};
    background: linear-gradient(to bottom, #fff8ef, #fff);
    border-top: ${props => (props.theme.isSp ? '1px solid #cfccc9' : 'none')};
    overflow: hidden;

    img {
      margin: 0 auto;
      display: block;
    }

    img:first-child {
      width: 310px;
    }

    img:last-child {
      width: ${props => (props.theme.isSp ? '326px' : '100%')};
    }
  }

  h2 {
    margin-bottom: 10px;
    padding: 8px;
    position: relative;
    background: linear-gradient(to right, #9ed870, #d1f1b1);
    color: #333;
    ${mixin.fontSize(14)};
    font-weight: bold;
    text-align: left;

    &::before {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: #fff;
      ${mixin.fontSize(30)};
      vertical-align: middle;
    }

    span {
      padding-left: 3.5rem;
      display: inline-block;
    }

    img {
      width: 320px;
    }
  }

  h3 {
    margin: 0;
    padding: 14px 0 12px;
    background: linear-gradient(to bottom, #efffd7, #fff);
    color: #209000;
    font-size: unset;

    span {
      margin: 0 auto;
      width: 90%;
      display: block;
    }
  }
`;

/**
 * セクション - ベストアンサー、クリップ
 */
export const Section = styled('section')`
  p {
    margin: 0 auto;
    width: 90%;
    text-align: left;
  }

  a::before {
    color: #333;
  }

  strong {
    color: #eb5a98;
    font-weight: normal;
  }
`;

/**
 * セクション - ルール
 */
export const SectionRule = styled('section')`
  ${props =>
    props.theme.isSp ? '' : `background: url(${EnvConstant.API_COMMON_PANE_URL}/img/lounge/caption_about_rule_bg.png) no-repeat center top;`};
  position: relative;

  nav {
    position: absolute;
    top: ${props => (props.theme.isSp ? '5px' : '26px')};
    right: 0;
    z-index: 1;
    ${props => (props.theme.isSp ? mixin.fontSize(12) : mixin.fontSize(14))};

    a {
      margin-right: 10px;
    }
  }

  h2 {
    padding: 0;
    background: ${props => (props.theme.isSp ? 'linear-gradient(to bottom, #efffd7, #fff)' : 'none')};
    ${props => (props.theme.isSp ? 'border-top: 2px solid #9ed870' : '')};
    ${props => (props.theme.isSp ? 'border-bottom: 1px solid #9ed870' : '')};
    text-align: center;

    img {
      ${props => (props.theme.isSp ? '' : 'margin-top: 54px;')};
      width: ${props => (props.theme.isSp ? '320px' : 'initial')};
    }
  }

  p {
    margin: 0;
  }

  dl {
    margin: ${props => (props.theme.isSp ? '0 auto' : '40px auto 0')};
    width: 90%;
  }

  dt {
    color: #209000;
    font-weight: bold;
    margin-bottom: 3px;

    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  dd {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 10px;
      border-bottom: 1px dotted #9ed870;
    }
  }

  ul {
    margin: 3px 0;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid #ccc;
    color: #209000;
    font-weight: bold;
  }
`;

/**
 * セクション - 注意事項、運営方針
 */
export const SectionAttention = styled('section')`
  border-top: 1px solid #9ed870;

  h3 + p {
    border-top: 1px dotted #9ed870;
  }

  p {
    margin: 0 auto;
    padding: 12px 0 0;
    width: 90%;
  }
`;

/**
 * ラウンジ内のリンク
 */
export const Link = styled('div')`
  margin: 10px 0;
  text-align: center;
`;
